import React, { useEffect, useState } from 'react';
import { Switch, Redirect, useHistory } from 'react-router-dom';

import { RouteWithLayout } from './components';
import { Main as MainLayout, Minimal as MinimalLayout } from './layouts';

import { autoLogin, roleSelector } from './store/login';
import { useSelector, useDispatch } from 'react-redux';

import {
  Order as OrderView,
  OrderList as OrderListView,
  ReportMoney as ReportMoneyView,
  ReportDaysMoney as ReportDaysMoneyView,
  ReportMeal as ReportMealView,
  Chekin as ChekinyView,
  Bar as BarView,
  Team as TeamView,
  Dishes as DishesView,
  DailyMenu as DailyMenuView,
  Accounts as AccountsView,
  NotFound as NotFoundView
} from './views';

const Routes = ({ history }) => {
  const [autoLoginFinished, setAutoLoginFinished] = useState(false);

  const userRole = useSelector(roleSelector);
  const dispatch = useDispatch();
  const location = useHistory().location;

  useEffect(() => {
    const getData = async () => {
      // Попробуем авторизоваться по данным из локал стораджа или по токену в урле
      await dispatch(autoLogin(location));
      setAutoLoginFinished(true);
    };
    getData();
  }, [dispatch]);

  if (!autoLoginFinished) return null;
  else
    return (
      <Switch>
        <Redirect exact from="/" to="/orders" />
        {/* <RouteWithLayout
        component={DashboardView}
        exact
        layout={MainLayout}
        path="/dashboard"
      /> */}
        {/* <RouteWithLayout
        component={UserListView}
        exact
        layout={MainLayout}
        path="/users"
      /> */}
        <RouteWithLayout
          component={OrderListView}
          exact
          layout={MainLayout}
          path="/orders"
          roles={['manager', 'admin']}
        />

        <RouteWithLayout
          component={AccountsView}
          exact
          layout={MainLayout}
          path="/accounts"
          roles={['admin']}
        />
        <RouteWithLayout
          component={ReportMoneyView}
          exact
          layout={MainLayout}
          path="/money"
          roles={['admin']}
        />

        <RouteWithLayout
          component={ReportDaysMoneyView}
          exact
          layout={MainLayout}
          path="/days_money"
          roles={['admin']}
        />

        <RouteWithLayout
          component={ReportMealView}
          exact
          layout={MainLayout}
          path="/meal"
          roles={['manager', 'admin']}
        />

        <RouteWithLayout
          component={ReportMealView}
          exact
          layout={MinimalLayout}
          path="/meal_report"
          roles={['manager', 'admin']}
        />
        <RouteWithLayout
          component={DishesView}
          exact
          layout={MainLayout}
          path="/dishes"
          roles={['manager', 'admin']}
        />
        <RouteWithLayout
          component={DailyMenuView}
          exact
          layout={MainLayout}
          path="/daily_menu"
          roles={['manager', 'admin']}
        />

        <RouteWithLayout
          component={ChekinyView}
          exact
          layout={MinimalLayout}
          path="/checkin"
          roles={['manager', 'admin', 'staff']}
        />
        <RouteWithLayout
          component={BarView}
          exact
          layout={MinimalLayout}
          path="/bar"
          roles={['manager', 'admin', 'staff']}
        />
        <RouteWithLayout
          component={TeamView}
          exact
          layout={MinimalLayout}
          path="/team/:id"
          roles={['manager', 'admin', 'staff']}
        />
        {/* <RouteWithLayout
        component={IconsView}
        exact
        layout={MainLayout}
        path="/icons"
      />  */}
        <RouteWithLayout
          component={OrderView}
          exact
          layout={MainLayout}
          path="/order/:id"
          roles={['manager', 'admin']}
        />
        {/* <RouteWithLayout
        component={SettingsView}
        exact
        layout={MainLayout}
        path="/settings"
      />
      <RouteWithLayout
        component={SignUpView}
        exact
        layout={MinimalLayout}
        path="/sign-up"
      />
      <RouteWithLayout
        component={SignInView}
        exact
        layout={MinimalLayout}
        path="/sign-in"
      /> */}
        <RouteWithLayout
          component={NotFoundView}
          exact
          layout={MinimalLayout}
          path="/not-found"
        />
        <Redirect to="/not-found" />
      </Switch>
    );
};

// export default withRouter(Routes);

export default Routes;
